import React from 'react';

const spinnerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(255,255,255,0.7)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const dotStyle: React.CSSProperties = {
  width: 18,
  height: 18,
  margin: 8,
  borderRadius: '50%',
  background: '#039be5',
  animation: 'spinner-bounce 1s infinite alternate',
};

const GlobalSpinner: React.FC = () => (
  <div style={spinnerStyle}>
    <div style={{ display: 'flex' }}>
      <div style={{ ...dotStyle, animationDelay: '0s' }} />
      <div style={{ ...dotStyle, animationDelay: '0.2s' }} />
      <div style={{ ...dotStyle, animationDelay: '0.4s' }} />
    </div>
    <style>{`
      @keyframes spinner-bounce {
        0% { transform: translateY(0); }
        100% { transform: translateY(-24px); }
      }
    `}</style>
  </div>
);

export default GlobalSpinner; 